import { render, staticRenderFns } from "./RatingViewWidgetServiceProvider.vue?vue&type=template&id=57c9ef4c&"
import script from "./RatingViewWidgetServiceProvider.vue?vue&type=script&lang=js&"
export * from "./RatingViewWidgetServiceProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports